import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { HeaderProps } from './types';

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    padding: '16px 12px'
  },
  header__title: {
    margin: 0,
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 400,
    color: '#fff',
    textAlign: 'center'
  },
  header__button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    inlineSize: '26px',
    blockSize: '26px',
    padding: 0,
    border: 0,
    borderRadius: '8px',
    backgroundColor: '#292929',
    color: '#fff',
    cursor: 'pointer',
    '&:focus-visible': {
      outline: '2px solid #ffd47f',
      outlineOffset: '2px'
    }
  }
}));

export const Header: FC<HeaderProps> = ({ title, onBack, onClose }) => {
  const classes = useStyles();

  return (
    <header className={classes.header}>
      <button
        type="button"
        onClick={onBack}
        className={classes.header__button}
        aria-label="Back"
        data-test-id="payment-form-back-button"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M12.5 5L7.5 10L12.5 15" stroke="currentColor" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      <h1 className={classes.header__title}>{title}</h1>
      <button
        type="button"
        onClick={onClose}
        className={classes.header__button}
        aria-label="Close"
        data-test-id="payment-form-close-button"
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M1.2 1.2L10.8 10.8M10.8 1.2L1.2 10.8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </button>
    </header>
  );
};

export default Header;
